const footerLinks = [
  { href: '#index', label: '差异索引' },
  { href: '#dimensions', label: '对比维度' },
  { href: '#digest', label: '参考清单' },
  { href: '#guide', label: '平替指引' },
  { href: '#faq', label: '常见问题' },
];

const topics = ['同类', '平替', '相似', '对比', '新选择', '推荐参考'];

export default function Footer() {
  return (
    <footer className="w-full bg-secondary-100 border-t border-secondary-200/70">
      <div className="w-full px-4 md:px-8 max-w-6xl mx-auto py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 font-heading text-lg text-foreground-950 mb-4">
              <span className="w-7 h-7 flex items-center justify-center">
                <i className="ri-article-line text-xl" />
              </span>
              黑料网站
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-xs">
              一份安静的对比参考索引。帮你在换一家、找新选择之前，先把同类站点之间的差别看明白。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950 mb-4">
              <a href="#top" className="hover:text-primary-600 transition-colors cursor-pointer">
                页面索引
              </a>
            </h4>
            <ul className="flex flex-col gap-3">
              {footerLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950 mb-4">
              <a href="#index" className="hover:text-primary-600 transition-colors cursor-pointer">
                参考方向
              </a>
            </h4>
            <div className="flex flex-wrap gap-2">
              {topics.map((topic) => (
                <span
                  key={topic}
                  className="px-3 py-1 rounded-full text-xs bg-secondary-200/70 text-secondary-900 whitespace-nowrap"
                >
                  {topic}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-secondary-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} 黑料网站 · 对比参考索引站
          </p>
          <p className="text-xs text-foreground-500">页面内容仅为参考整理，不构成任何建议。</p>
        </div>
      </div>
    </footer>
  );
}